import React from 'react';
import { GENERIC_FILTER_PARAM_LOGS } from 'features/logs/queries';
import { DOCUMENT_TYPES_QUERY } from 'features/logs/queries';
import { Card } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ListBrowser, { CollectionType, getListBrowserStore } from '@ts-private/list-browser';
import GenericFilterParamLogComponent from './GenericFilterParamLogComponent';
import ExportModalComponent from 'features/common/export/ExportModalComponent';
import { useListBrowserFunctions } from 'utils/hooks/useListBrowserFunctions';
import { useApolloFetching } from '@ts-private/list-browser-apollo-extensions';
import useGenericLogFilters from './useGenericLogFilters';

export const logsStore = getListBrowserStore({
  name: 'generic-logs-browser',
  filterDefinitions: [
    {
      name: 'documentNumber',
      caption: 'GenericFilterParamLogs.DocumentNumber',
      type: 'text'
    },
    {
      name: 'partnerId',
      caption: 'GenericFilterParamLogs.PartnerId',
      type: 'integer'
    },
    {
      name: 'documentTypeId',
      caption: 'GenericFilterParamLogs.DocumentTypes',
      type: 'select',
      underlyingType: 'number'
    },
    {
      name: 'method',
      caption: 'GenericFilterParamLogs.Method',
      type: 'text'
    },
    {
      name: 'operator',
      caption: 'GenericFilterParamLogs.Operator',
      type: 'text'
    },
    {
      name: 'logDate',
      caption: 'GenericFilterParamLogs.LogDate',
      type: 'date'
    },
    {
      name: 'logTime',
      caption: 'GenericFilterParamLogs.LogTime',
      type: 'time'
    },
    {
      name: 'logEndDate',
      caption: 'GenericFilterParamLogs.LogEndDate',
      type: 'date'
    },
    {
      name: 'logEndTime',
      caption: 'GenericFilterParamLogs.LogEndTime',
      type: 'time'
    }
  ],
  orderByFields: [
    {
      caption: 'GenericFilterParamLogs.LogDate',
      value: 'LogDate'
    }
  ],
  pager: {
    orderBy: 'LogDate',
    direction: 'desc'
  }
});

const logsFetchingOptions = {
  queryOptions: { query: GENERIC_FILTER_PARAM_LOGS, name: 'genericFilterParamLogs', fetchPolicy: 'network-only' },
  collectionsOptions: [
    {
      queryOptions: { query: DOCUMENT_TYPES_QUERY },
      name: 'documentTypes',
      identifier: 'documentTypeId',
      collectionType: CollectionType.Filter,
      valueKey: 'id',
      labelKey: 'name'
    }
  ]
};

const GenericFilterParamLogListBrowser = () => {
  useApolloFetching(logsStore, logsFetchingOptions);
  const { textResolver } = useListBrowserFunctions();

  useGenericLogFilters();
  return (
    <Card icon={ListAltIcon}>
      <ListBrowser store={logsStore} ItemComponent={GenericFilterParamLogComponent} textResolver={textResolver} />
      <ExportModalComponent store={logsStore} options={logsFetchingOptions} />
    </Card>
  );
};

export default GenericFilterParamLogListBrowser;
